import { useQueryApi } from 'utils/api'

import type { UseQueryOptions } from 'react-query'
import type { TJenjangSelection } from 'types/assessment'

export function useAPIJenjangSelection(
  options?: UseQueryOptions<TJenjangSelection[]>
) {
  return useQueryApi<TJenjangSelection[]>(
    `${process.env.NEXT_PUBLIC_GURU_ADMIN_FRONTEND_CDN}/assets/jenjang-selections.json`,
    {
      queryConfig: {
        useErrorBoundary: false,
        ...options,
      },
    }
  )
}
